const state = {
  imgList: [],
  imgState:false,
}

const getters = {
  imgList: state => {
    return state.imgList
  },
  imgState:state => {
    return state.imgState
  }
}

const mutations = {
  setImgList: (state, data) => {
    state.imgList = data
  },
  setImgState:(state,data)=>{
    state.imgState = data
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modelState/img_loop.js